import { payerActionTypes } from './../constants/ApiConstants';
const initialState = {
  get_payer_data: null,
  get_payer_data_by_id: null,
  save_payer_data: null,
  delete_payer_data: null,
  master_data: {},
  save_payer_service_code_data: null,
  get_payer_or_master_service_code: null,
  get_payer_service_code_by_id: null,
  delete_payer_service_code: null,
  masterServiceCodeDetails: null,
  payerActivityData: null,
  deletePayerActivityCode: null,
  activity_service_codes: null,
  excluded_cpt_codes: null,
  activityServiceCodeById: null,
  payerServiceCodeDetailsData: null,
  updateCodeModifier: null,
  saveActivityCode: null,
  saveSingleCPTCode: null,
  payerActivityActiveStatus: false,
  copyPayerData : null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case payerActionTypes.get_payers_list.REQUEST:
    return {
      ...state,
      loading: true,
      get_payer_data: null,
    };
  case payerActionTypes.get_payers_list.SUCCESS:
    return {
      ...state,
      loading: false,
      get_payer_data: payload,
    };
  case payerActionTypes.post_payer_info.REQUEST:
    return {
      ...state,
      loading: true,
      save_payer_data: null,
    };
  case payerActionTypes.post_payer_info.SUCCESS:
    return {
      ...state,
      loading: false,
      save_payer_data: payload,
    };
  case payerActionTypes.post_payer_info.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case payerActionTypes.get_payer_info_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      get_payer_data_by_id: null,
    };
  case payerActionTypes.get_payer_info_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      get_payer_data_by_id: payload,
    };
  case payerActionTypes.delete_payer_info.REQUEST:
    return {
      ...state,
      loading: true,
      delete_payer_data: null,
    };
  case payerActionTypes.delete_payer_info.SUCCESS:
    return {
      ...state,
      loading: false,
      delete_payer_data: payload,
    };
  case payerActionTypes.get_master_data.REQUEST:
    return {
      ...state,
      loading: true,
      master_data: {},
    };
  case payerActionTypes.get_master_data.SUCCESS:
    return {
      ...state,
      loading: false,
      master_data: payload,
    };
  case payerActionTypes.get_master_state_by_countryid.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case payerActionTypes.get_master_state_by_countryid.SUCCESS:
    return {
      ...state,
      loading: false,
      masterStateByCountryId: payload,
    };
  case payerActionTypes.get_payer_or_master_service_codes.REQUEST:
    return {
      ...state,
      loading: true,
      get_payer_or_master_service_code: null,
    };
  case payerActionTypes.get_payer_or_master_service_codes.SUCCESS:
    return {
      ...state,
      loading: false,
      get_payer_or_master_service_code: payload,
    };
  case payerActionTypes.reset_ServiceCodeDetails.REQUEST:
    return {
      ...state,
      masterServiceCodeDetails: null,
      get_payer_service_code_by_id: null,
    };
  case payerActionTypes.save_payer_service_codes.REQUEST:
    return {
      ...state,
      loading: true,
      save_payer_service_code_data: null,
    };
  case payerActionTypes.save_payer_service_codes.SUCCESS:
    return {
      ...state,
      loading: false,
      save_payer_service_code_data: payload,
    };
  case payerActionTypes.save_payer_service_codes.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case payerActionTypes.get_payer_service_code_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      get_payer_service_code_by_id: null,
    };
  case payerActionTypes.get_payer_service_code_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      get_payer_service_code_by_id: payload,
    };
  case payerActionTypes.delete_payer_service_code.REQUEST:
    return {
      ...state,
      loading: true,
      delete_payer_service_code: null,
    };
  case payerActionTypes.delete_payer_service_code.SUCCESS:
    return {
      ...state,
      loading: false,
      delete_payer_service_code: payload,
    };
  case payerActionTypes.get_all_payer_cpt_codes_by_payer.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case payerActionTypes.get_all_payer_cpt_codes_by_payer.SUCCESS:
    return {
      ...state,
      loading: false,
      payerAllCptCodesByPayer: payload,
    };
  case payerActionTypes.get_masterservicecode_by_Id.REQUEST:
    return {
      ...state,
      loading_servicecodedetails: true,
      masterServiceCodeDetails: null,
    };
  case payerActionTypes.get_masterservicecode_by_Id.SUCCESS:
    return {
      ...state,
      loading_servicecodedetails: false,
      masterServiceCodeDetails: payload,
    };
  case payerActionTypes.get_payer_activity.REQUEST:
    return {
      ...state,
      loading: true,
      payerActivityData: null,
    };
  case payerActionTypes.get_payer_activity.SUCCESS:
    return {
      ...state,
      loading: false,
      payerActivityData: payload,
    };
  case payerActionTypes.delete_payer_activity_code.REQUEST:
    return {
      ...state,
      loading: true,
      deletePayerActivityCode: null,
    };
  case payerActionTypes.delete_payer_activity_code.SUCCESS:
    return {
      ...state,
      loading: false,
      deletePayerActivityCode: payload,
    };
  case payerActionTypes.get_master_activity_for_payer.REQUEST:
    return {
      ...state,
      loading: true,
      activity_for_payer: null,
    };
  case payerActionTypes.get_master_activity_for_payer.SUCCESS:
    return {
      ...state,
      loading: false,
      activity_for_payer: payload,
    };
  case payerActionTypes.get_payer_activity_service_codes.REQUEST:
    return {
      ...state,
      loading: true,
      activity_service_codes: null,
    };
  case payerActionTypes.get_payer_activity_service_codes.SUCCESS:
    return {
      ...state,
      loading: false,
      activity_service_codes: payload,
    };
  case payerActionTypes.excluded_service_codes.REQUEST:
    return {
      ...state,
      loading: true,
      excluded_cpt_codes: null,
    };
  case payerActionTypes.excluded_service_codes.SUCCESS:
    return {
      ...state,
      loading: false,
      excluded_cpt_codes: payload,
    };
  case payerActionTypes.get_activity_service_code_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      payerServiceCodeDetailsData: null,
    };
  case payerActionTypes.get_activity_service_code_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      payerServiceCodeDetailsData: payload,
    };
  case payerActionTypes.get_payer_servicecode_by_Id.REQUEST:
    return {
      ...state,
      loading_servicecodedetails: true,
      masterServiceCodeDetails: null,
      payerServiceCodeDetailsData: null,
    };
  case payerActionTypes.get_payer_servicecode_by_Id.SUCCESS:
    return {
      ...state,
      loading_servicecodedetails: false,
      payerServiceCodeDetailsData: payload,
    };
  case payerActionTypes.update_activity_service_code_modifier.REQUEST:
    return {
      ...state,
      loading: true,
      updateCodeModifier: null,
    };
  case payerActionTypes.update_activity_service_code_modifier.SUCCESS:
    return {
      ...state,
      loading: false,
      updateCodeModifier: payload,
    };
    case payerActionTypes.save_new_service_code_in_activity.REQUEST:
    return {
      ...state,
      loading: true,
      saveActivityCode: null,
    };
  case payerActionTypes.save_new_service_code_in_activity.SUCCESS:
    return {
      ...state,
      loading: false,
      saveActivityCode: payload,
    };
  case payerActionTypes.save_new_service_code_in_activity.FAILURE:
    return {
      ...state,
      loading: false,
      saveActivityCode: null,
    };
  case payerActionTypes.save_single_payer_service_code.REQUEST:
    return {
      ...state,
      loading: true,
      saveSingleCPTCode: null,
    };
  case payerActionTypes.save_single_payer_service_code.SUCCESS:
    return {
      ...state,
      loading: false,
      saveSingleCPTCode: payload,
    };
  case payerActionTypes.patch_payeractivity_active_status.REQUEST:
      return {
        ...state,
        loading: true,
        payerActivityActiveStatus: false,
      };
  case payerActionTypes.patch_payeractivity_active_status.SUCCESS:
      return {
        ...state,
        payerActivityActiveStatus: payload,
        loading: false,
      };
  case payerActionTypes.post_copy_payer_data.REQUEST:
      return {
        ...state,
        loading: true,
        copyPayerData: false,
      };
  case payerActionTypes.post_copy_payer_data.SUCCESS:
      return {
        ...state,
        loading: false,
        copyPayerData: payload,
      };
  default:
    return {
      ...state,
    };
  }
};



// WEBPACK FOOTER //
// ./src/modules/Payers/reducers/index.js